<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container flex-grow-1 container-p-y">
			<div class="row mb-12 g-6">
				<div class="col-md-12 col-lg-12" style="text-align: center;">
					<div class="card">
						<div class="card-body">
							<CheckIcon />
							<h5 class="card-title mt-10">Formations commandées en cours de livraison.</h5>
							<p class="card-text">
								D'ici quelques secondes vos stagiaires vont recevoir un email afin de pouvoir commencer leurs formations respectives.
							</p>
							<router-link to="/trainings/list">
								<a href="javascript:void(0)" class="btn btn-primary mt-10">Voir vos stagiaires</a>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import CheckIcon from "@/components/CheckIcon";

export default {
	name: "TrainingPayment",

	components: {CheckIcon},

	data() {
		return {
			status: null,
		};
	},

	methods: {

	},

	async mounted() {
		this.status = this.$route.query.status;
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
